const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 64
  },
  cardsHeading: {
    display: 'flex',
    // justifyContent: 'space-evenly',
    marginLeft: '20px',
    alignItems: 'left'
  },
  allCards: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  }
})

export default styles
